// UI Constants
export const UI_CONSTANTS = {
  SIZES: {
    MIN_HEIGHT: '40px',
    ICON_SIZE: 16,
    ARROW_SIZE: 22,
    TAG_HEIGHT: '32px',
    SCROLLBAR_WIDTH: '6px',
    SCROLLBAR_HEIGHT: '4px',
  },
  Z_INDEX: {
    DROPDOWN: 9999,
  },
  DEBOUNCE: {
    SEARCH_DEFAULT: 300,
  },
  KEYS: {
    ESCAPE: 'Escape',
    ENTER: 'Enter',
    SPACE: ' ',
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
  },
  SPECIAL_VALUES: {
    ALL: '__ALL__',
  },
  MESSAGES: {
    LOADING: 'Cargando...',
    NO_OPTIONS: 'No hay opciones disponibles',
    NO_SEARCH_RESULTS: 'No se encontraron opciones',
    CLEAR_SELECTION: 'Limpiar selección',
    SEARCH_PLACEHOLDER: 'Buscar...',
    SELECT_ALL: 'Seleccionar todo',
    DESELECT_ALL: 'Deseleccionar todo',
  },
} as const;
